import './application.scss';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore, { persistor } from './store/configureStore';
import App from './App';
import { ThemeProvider } from './components/ThemeProvider';
import AuthProvider from './store/providers/AuthProvider.jsx';
import { PersistGate } from 'redux-persist/integration/react';
import './i18n';
import 'core-js/stable';
import { BrowserRouter } from 'react-router-dom';
import { StyleProvider } from '@ant-design/cssinjs';

import './store/actions/auth/Auth';

const initialState = window.initialReduxState;
const store = configureStore(initialState);

const rootElement = document.getElementById('root');

ReactDOM.createRoot(rootElement).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor(store)}>
      <BrowserRouter>
        <Suspense fallback="Loading">
          <StyleProvider hashPriority="high" layer>
            <AuthProvider>
              <ThemeProvider>
                <App />
              </ThemeProvider>
            </AuthProvider>
          </StyleProvider>
        </Suspense>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);